import { useContext } from 'react';
import { WorkingContext, type WorkingContextValue } from '@/app/providers/WorkingContextProvider';

/**
 * The campus and academic year the current page is scoped to.
 *
 * Throws outside the provider rather than returning a neutral default: a list
 * that silently ignored the working context would show the wrong year without
 * anything looking wrong, which is far harder to notice than a crash on first
 * render.
 */
export function useWorkingContext(): WorkingContextValue {
  const value = useContext(WorkingContext);
  if (value === null) {
    throw new Error('useWorkingContext must be used inside <WorkingContextProvider>');
  }
  return value;
}
